//build해서 로컬에서 돌릴때에는 root_url을 ""로, payment_root_url을 "http://localhost"로 바꿔줘야함
//local test: root="http://localhost:8080", payment_root_url="http://localhost:8080"
let _root_url = "";
let _payment_root_url = "";
let _clientKey = "";

if (
  (window.location.hostname === "www.dcmarathon.or.kr" ||
    window.location.hostname === "dcmarathon.or.kr") && window.location.port == ""
) {
  //production environment
  if (window.location.protocol === "https:") {
    _root_url = "https://www.dcmarathon.or.kr";
    _payment_root_url = "https://www.dcmarathon.or.kr/api";
  }
  else {
    _root_url = "http://www.dcmarathon.or.kr";
    _payment_root_url = "http://www.dcmarathon.or.kr/api";
  }
  _clientKey = "live_ck_jkYG57Eba3GgWAvjO93pWDOxmA1Q";
} else if (window.location.port === "90") {
  // staging 환경 : nginx가 90 포트에서 열리고, 프론트 정적 파일 제공 or 서버(None:8080)로 프록시
  _root_url = window.location.protocol + "//" + window.location.hostname + ":90";
  _payment_root_url = window.location.protocol + "//" + window.location.hostname + ":90/api";
  _clientKey = "test_ck_dP9BRQmyarYOnR7Aov3J07KzLNkE";
}
else {
  //local 환경
  _root_url = window.location.origin;
  _payment_root_url = window.location.origin;
  _clientKey = "test_ck_dP9BRQmyarYOnR7Aov3J07KzLNkE";
}
// CRA local test
// console.log("root_url: ", _root_url);
// console.log("payment_root_url: ", _payment_root_url);
// console.log("clientKey: ", _clientKey);

export const root_url = _root_url;
export const payment_root_url = _payment_root_url;
export const clientKey = _clientKey;
